/**
 * B545 (f) — the hold deadline, asked in ONE place. A checkout that froze no
 * holds (capacity-NONE products) answers `held: false`: nothing lapses, so
 * the order has no deadline — no strip, no expiry arrow, polling continues.
 * Before this the wire's `holdExpiresAt: now` read as a lapsed hold on the
 * first clock tick ("Your hold ended" on the FIRST Continue).
 */
import type { FlowState } from "./flow.js";

export function holdDeadline(res: { readonly holdExpiresAt: number; readonly held?: false }): number {
  return res.held === false ? Number.POSITIVE_INFINITY : res.holdExpiresAt;
}

/** Time left on a live, unpaid hold — undefined when there is no strip to draw. */
export function holdMsLeft(flow: FlowState, now: number): number | undefined {
  if (flow.phase !== "PENDING_PAYMENT" || flow.authorized) return undefined;
  if (!Number.isFinite(flow.holdExpiresAt)) return undefined;
  return flow.holdExpiresAt - now;
}
